import WorkflowInstances from './WorkflowInstances'

export default WorkflowInstances
